export default __webpack_public_path__ + "static/media/Slider8.1f780491.jpg";